define('RecipesAndEvents.Facets.ItemCell.View', [
    'Facets.ItemCell.View',
    'SC.Configuration',
    'underscore'
], function RecipesAndEventsFacetsItemCellView(
    FacetsItemCellView,
    Configuration,
    _
) {
    'use strict';

    _.extend(FacetsItemCellView.prototype, {
        getContext: _.wrap(FacetsItemCellView.prototype.getContext, function getContext(fn) {
            var originalContext = fn.apply(this, _.toArray(arguments).slice(1));
            var typesExcluded = Configuration.get('recipesAndEvents.typesExcluded') || [];
            var isItem = this.model.get('custitem_item_type');
            originalContext.isLandingOrArticle = !isItem || typesExcluded.indexOf(isItem) >= 0;
            originalContext.isEnvironmentBrowser = originalContext.isEnvironmentBrowser && isItem === 'Item';
            return originalContext;
        })
    });
});
